import {Base} from "@/api/Base"

export class RemainingVacationPrediction extends Base {
    path = "remainingVacation/prediction"
}